import { Dispatch, FC, SetStateAction, useEffect } from 'react';
import styled from 'styled-components';
import { border, BorderProps, color, ColorProps, DisplayProps } from 'styled-system';
import { HStack, Span, Text, VStack } from '@bpba/ui-components';
import OtpInput from 'react-otp-input';
import { OTP_LENGTH } from '../../constants/data';

const ORDINAL_NUMBERS = ['primer', 'segundo', 'tercer', 'cuarto', 'quinto', 'sexto'];

type Props = {
  otp: string | undefined;
  setOtp: Dispatch<SetStateAction<string | undefined>>;
  onComplete?: () => void;
  ariaHidden: boolean;
} & DisplayProps;

export const FormularioOtp: FC<Props> = ({ otp, setOtp, onComplete, ...otherProps }) => {
  useEffect(() => {
    if (onComplete && otp && otp.length === OTP_LENGTH) onComplete();
  }, [otp, onComplete]);

  return (
    <VStack {...otherProps} aria-hidden={otherProps.ariaHidden}>
      <Text color="primary.0" tabIndex={0} py={'16px'}>
        Ingresá el código enviado a tu e-mail
      </Text>
      <HStack justifyContent="center" marginBottom="8px">
        <OtpInput
          value={otp}
          inputType="number"
          onChange={setOtp}
          numInputs={OTP_LENGTH}
          renderSeparator={
            <Span mx={['4px', '8px']} color="primary.0">
              -
            </Span>
          }
          renderInput={(props, index) => (
            <StyledOTP
              borderBottomColor="primary.0"
              color="primary.0"
              outlineColor={'tertiary.0'}
              {...props}
              aria-label={getInputLabel(index)}
            />
          )}
        />
      </HStack>
    </VStack>
  );
};
/** Se cambia aria-label para los inputs del OTP, ya que sino se leen en inglés. */
function getInputLabel(index: number) {
  return `Por favor ingresá el ${ORDINAL_NUMBERS[index]} número del código.`;
}

export const validateOTP = (otp: string | undefined) => {
  return otp !== undefined && otp.length === OTP_LENGTH;
};

type StyledOTPprops = {
  outlineColor?: string;
} & BorderProps &
  ColorProps;
const StyledOTP = styled.input<StyledOTPprops>(
  border,
  color,
  {
    padding: '0px !important',
    color: 'rgb(39, 157, 46) !important',
    fontSize: '40px !important',
    height: '50px !important',
    border: '0px',
    borderBottomWidth: '2px',
    borderBottomStyle: 'solid',
    userSelect: 'none',
    caretColor: 'transparent',
    '&::selection': {
      backgroundColor: 'transparent',
    },
    textAlign: 'center',
    '&::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
    '&::-webkit-outer-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
  },
  (props) => ({
    'outline-color': props.outlineColor,
  })
);
